import React, { useEffect, useState } from "react"
import { confetti } from "dom-confetti"
import "./confetti.css"

export const ConfettiBangbang = ({ anchor }) => {
  const [count, increaseCount] = useState(0)
  const config = {
    angle: "90",
    spread: "45",
    startVelocity: "59",
    elementCount: "90",
    dragFriction: "0.11",
    duration: "2330",
    stagger: "0",
    width: "10px",
    height: "15px",
    colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
  }
  useEffect(() => {
    count && anchor && confetti(anchor.current, config)
  }, [count])

  return (
    <button
      onClick={() => increaseCount(count + 1)}
      className="hvr-buzz hurrabutton"
    >
      HURRA!!
    </button>
  )
}
